<template>
  <section class="cordel-filters-form">
    <form-sections
      :schema="schema"
      buttonless
      @change="input"
    />
  </section>
</template>

<script>
  /* eslint no-underscore-dangle: ["error", { "allow": ["_active"] }] */

  import form from '@cordel/helpers/form/mixin';

  import FormSections from '@cordel/components/Form/Sections.vue';

  import filter, { unequal, querify } from '@sdk/helpers/query/filter';

  const MAX = 'max';

  export const ALWAYS_VISIBLE = 'always-visible';

  export default {
    name: 'CordelFiltersForm',
    components: {
      FormSections,
    },
    mixins: [
      form,
    ],
    props: {
      scrollable: {
        type: Boolean,
        default: true,
      },
      perPage: {
        type: Number,
        default: null,
      },

      loading: {
        type: Boolean,
        default: false,
      },
      items: {
        type: [Array, Object],
        default() {
          return {};
        },
      },

      filters: {
        type: Object,
        default() {
          return {};
        },
      },
      actions: {
        type: Object,
        default() {
          return {
            filter: null,
            clear: null,
            list: null,
          };
        },
      },

      schema: {
        type: Object,
        default() {
          return {
            fields: {},
          };
        },
      },
      payload: {
        type: Object,
        default() {
          return {};
        },
      },

      initial: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        count: 0,

        timeout: null,
        listenerTimeout: null,

        updating: null,
      };
    },
    computed: {
      filtered() {
        const filtered = filter(this.filters, this.initial);

        delete filtered._active;
        delete filtered.page;
        delete filtered.per_page;

        return filtered;
      },
      queried() {
        return filter(querify(this.$route.query), this.initial);
      },

      pagination() {
        return this.perPage || this.filters.per_page;
      },
      length() {
        return (Array.isArray(this.items) ? this.items : Object.keys(this.items)).length;
      },
    },
    watch: {
      filters(after, before) {
        this.query();
        this.force();

        if (before._active && !after._active) {
          this.pre(0);
        }
      },
      'filters._active': function active(bool) {
        this.toggle(bool);
      },
    },
    mounted() {
      const active = !!Object
        .keys(this.queried)
        .filter(id => !/^header_/.test(id))
        .length;

      this.toggle(active);

      this.pre(0, {
        ...this.queried,
        _active: active,
      });

      if (this.scrollable) {
        this.listenerTimeout = setTimeout(() => {
          window.addEventListener('scroll', this.scroll, { passive: true });
        }, 1000);
      }
    },
    beforeDestroy() {
      clearTimeout(this.timeout);
      clearTimeout(this.listenerTimeout);

      window.removeEventListener('scroll', this.scroll, { passive: true });
    },
    methods: {
      pre(page, filters = {}) {
        const { dispatch } = this.$store;
        const data = page ? this.getJSON(this.payload) : this.initial;

        const filtered = filters;

        Object.keys(data)
          .filter(id => /^header_/.test(id))
          .forEach((id) => {
            this.initial[id] = data[id];
            filtered[id] = data[id];
          });

        dispatch(this.actions.filter, {
          ...data,
          ...filtered,

          page: page || 1,
          per_page: this.pagination || this.initial.per_page,
          CRUDL_append: page > 1,
        }).then(this.getTimeout);
      },

      getTimeout() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.get,
          this.updating && this.updating.type !== null ? 1000 : 0);
        this.updating = null;
      },
      get() {
        const { dispatch } = this.$store;

        if (this.filters.page <= 1) {
          dispatch(this.actions.clear, { action: 'list' });
        }

        this.count = this.length;

        dispatch(this.actions.list, this.filters).then(this.got);
      },
      got() {
        this.$nextTick(this.counter);
      },

      counter() {
        this.count = this.count === this.length ? MAX : this.length;
      },

      input(id) {
        this.updating = this.fields[id];
        this.pre(1);
      },
      scroll() {
        if (this.loading || this.count === MAX) {
          return;
        }

        const {
          scrollTop: top,
          scrollHeight: height,
        } = document.scrollingElement || document.documentElement || document.body || {};

        if (top && top + window.innerHeight + 240 >= height) {
          this.pre(this.filters.page + 1);
        }
      },

      query() {
        if (unequal(this.queried, this.filtered)) {
          this.$router.replace({
            query: this.filtered,
          });
        }
      },
      force() {
        const filters = Object
          .keys(this.filters)
          .reduce((reduced, key) => {
            const value = this.filters[key];

            if (Array.isArray(value) && (!value.length || value[0] === 0)) {
              reduced[key] = [null];
            } else {
              reduced[key] = value;
            }

            return reduced;
          }, {});

        this.setJSON(this.payload, filters, true);
      },

      toggle(bool) {
        Object.values(this.schema.fields)
          .forEach(field => this.updateVisible(
            field._ID, // eslint-disable-line no-underscore-dangle
            bool || field.subsection === ALWAYS_VISIBLE,
            { clear: false },
          ));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-filters-form {
  }
</style>
